<section class="teams pt-5">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <a routerLink="create-team" class="btn btn-primary"> انشاء فريق <i
                        class="ri-add-circle-line me-2"></i></a>
                <form class="mt-3" [formGroup]="form">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="teamName" class="form-label">اجمالي النقاط</label>
                                <ng-select [notFoundText]="'لا يوجد عناصر متاحة'" [clearable]="false" [items]="teams"
                                    bindLabel="name" [virtualScroll]="true" bindValue="_id"
                                    (change)="patchTeamPoints($event)" formControlName="team">
                                    <ng-template ng-label-tmp let-item="item">
                                        <span [ngStyle]="{'background-color': item.color}"
                                            class="bg__circle ms-3 me-2"></span> {{item.name}}
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                                        <span [ngStyle]="{'background-color': item.color}"
                                            class="bg__circle ms-3"></span>
                                        {{item.name}}
                                    </ng-template>
                                </ng-select>
                                <div class="form-control-feedback text-end"
                                    *ngIf="((form.get('team')?.touched) && (form.get('team')?.invalid))">
                                    <small *ngIf="form.get('team')?.errors?.['required']" class="text-danger">
                                        هذا الحقل مطلوب
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="teamPoints" class="form-label">اجمالي النقاط</label>
                                <input type="text" class="form-control" id="teamPoints" formControlName="points"
                                    placeholder="اجمالي النقاط">
                                <div class="form-control-feedback text-end"
                                    *ngIf="((form.get('points')?.touched) && (form.get('points')?.invalid))">
                                    <small *ngIf="form.get('points')?.errors?.['required']" class="text-danger">
                                        هذا الحقل مطلوب
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="d-flex justify-content-between my-5">
                    <button class="btn btn-primary" (click)="updatePoints()">
                        حفظ
                    </button>
                    <button class="btn btn-outline-secondary" (click)="form.reset()">
                        الغاء
                    </button>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>الفريق</th>
                                <th class="text-center">اجمالي النقاط</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let team of teams">
                                <td>
                                    <div class="d-flex align-items-center">
                                        <span class="bg__circle ms-3"
                                            [ngStyle]="{'background-color': team.color}"></span>
                                        <span> {{ team.name }} </span>
                                    </div>
                                </td>
                                <td class="text-center">{{ team.points }}</td>
                            </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>